import Grid from '@mui/material/Grid';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

const TicketIncidenceInfo = () => {
  return (
    <Grid container className='ticket-id-status'>
      <Grid item size={{ xs: 6 }}>
        <h2>
          <ConfirmationNumberIcon className='svg' /> {'D1234'}
        </h2>
      </Grid>
      <Grid item size={{ xs: 6 }}>
        {/* <TicketStatus ticketId={ticketStatus} /> */}
      </Grid>
    </Grid>
  );
};

export default TicketIncidenceInfo;
